import { makeStyles } from '@mui/styles';

const style = makeStyles((theme: any) => ({
  section: {
    position: 'relative',
    flexWrap: 'wrap',
    overflow: 'hidden',
    minHeight: '338px',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
  },

  coverImg: {
    backgroundColor: 'black',
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    zIndex: -1,
    '& > div': {
      height: '100%',
    },
    '& img': { height: '100%', objectFit: 'cover' },
  },

  absWrapper: {
    width: '74%',
  },
  overlap: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    padding: '0 16px',
    backgroundImage:
      'linear-gradient(90deg,rgba(0, 0, 0, 0.75),rgba(84, 84, 84, 0))',
  },
  textBox: {
    width: '100%',
    position: 'relative',
    margin: 'auto',
    textAlign: 'left',
    color: '#fff',
    '& > div:first-child': {
      height: '100%',
      display: 'flex',
      alignContent: 'space-between',
      flexDirection: 'column',
      '& paraContent': { margin: '20px 0' },
    },
  },
  [theme.breakpoints.up('sm')]: {
    section: {
      position: 'relative',
      minHeight: '393px',
      flexDirection: 'column',
      flexWrap: 'nowrap',
    },
    coverImg: {
      width: '100%',
      overflow: 'hidden',
      marginLeft: '0',
      marginTop: '0',
      height: '100%',
      maxHeight: '100%',
    },
    textBox: { '& paraContent': { margin: '20px 0 50px' } },
  },
  [theme.breakpoints.up('md')]: {
    absWrapper: { justifyContent: 'end' },

    textBox: {
      margin: '0',
      width: '520px',
      '& paraContent': { margin: '30px 0 40px' },
      '& > div:first-child': {
        maxWidth: '100%',
        alignContent: 'center',
      },
    },
  },
}));

export default style;
